
import { extendMoment } from "moment-range";

export default {
	methods: {
		// retourne un array contenant les numéros de semaine du mois
		weeksInMonth(year, month) {
			// Ajoute les fonctions de "moment-range"
			const moment = extendMoment(this.$moment)

			const startDate = moment([year, month])

			let firstDay = moment(startDate).startOf('month')
			if(moment(firstDay).format('d') === '0') {
				firstDay = moment(firstDay).add(1, 'day')
			}
			const endDay = moment(startDate).endOf('month')

			const monthRange = moment.range(firstDay, endDay)

			const weeks = []
			// retourne le premier jour de chaque semaine du mois
			const days = Array.from(monthRange.by('weeks'));
			days.forEach(day => {
				weeks.push(day.isoWeek())
			})

			return weeks
		}
	}
}
